/* eslint-disable import/prefer-default-export */
import _ from "lodash";

import { css } from "@emotion/react";

export const base = css`
  height: auto;
  min-height: 50px;
  resize: vertical;
  padding: 10px;
  line-height: 1.5;
`;
